import { getCookie } from "@core/helper/cookie";
import CsrfHiddenInputField from './component/csrf-hidden-input-field.vue';
var CsrfPlugin = /** @class */ (function () {
    function CsrfPlugin() {
    }
    CsrfPlugin.install = function (Vue) {
        Vue.component('csrf-hidden-input-field', CsrfHiddenInputField);
        Vue.mixin({
            methods: {
                $getCsrfToken: function () {
                    return getCookie('csrftoken');
                }
            }
        });
    };
    return CsrfPlugin;
}());
export default CsrfPlugin;
